// removed by extract-text-webpack-plugin
module.exports = {"typeAPreview":"_3Vx06U_HIYAIQcaIhpc524","typeBPreview":"_2F4ZRa8N1IZpaIq_srbXXx","typeCPreview":"_2axNfEOAmFvJdAMKdchLpm","typeDPreview":"In47NNxjITM4izizMgZBe","selfcareTypeAPreview":"DYD9BKe2zVECdhS9PuLT7","selfcareTypeBPreview":"_1ZOmr6Fibcl5-TxnqarrN1"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/components/Hotspots/constants/hotspotsSet.css
// module id = 1476
// module chunks = 0